import { useEffect, useRef } from "react";

export const useLatestRef = (obj) => {
  const ref = useRef(obj);
  ref.current = obj;
  return ref;
};

export const useScrollEvent = (scrollEvent) => {
  const eventRef = useLatestRef(scrollEvent);
  useEffect(() => {
    const event = () => {
      eventRef.current?.();
    };
    event();
    window.addEventListener("scroll", event);

    return () => {
      window.removeEventListener("scroll", event);
    };
  }, [eventRef]);
};
